module.exports = __webpack_public_path__ + "static/img/thumbnail.a772f9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/thumbnail.jpg
// module id = luwj
// module chunks = 1